import React, { Component } from 'react';
import $ from 'jquery';
import _ from "lodash";
import * as deviceInfoService from '../../utils/general/deviceInfoService';

interface IIFramePageProps {
    iframePageUrl: string;
    currentPage: string;
    iframeADATitle?: string;
    customScrollingOption?: string;
    iframeId?: string;
    hidden?: boolean;
    iframeStyle?: React.CSSProperties;
    iframeHolderStyle?: React.CSSProperties;
}

export class IFramePage extends Component<IIFramePageProps, any> {
    public elRef: any = React.createRef();
    public eleOffsetHeight: number = 0;
    public eleOffsetWidth: number = 0;
    public intervalId: NodeJS.Timeout | undefined = undefined;
    public eleIntervalId: NodeJS.Timeout | undefined = undefined;
    public triggerFGScrollEvent: boolean = false;
    constructor(props: IIFramePageProps) {
        super(props);
    }

    public componentDidMount() {
        if (this.props.currentPage === 'offTheCuff') {
            this.startDetectcOffTheCuff();
            return;
        }
        setTimeout(() => {
            const iframeEl = $('.rendition-iframe');

            if (iframeEl.length > 0) {
                const iframeResizer = $.proxy( () => {
                    this.calculateIframeHeight(iframeEl);
                }, this);

                iframeResizer();
                $(window).on('resize.' + this.props.currentPage + '.iframeResizer', _.throttle(_.bind(iframeResizer, this), 200));
                $(window).on('orientationchange.' + this.props.currentPage + '.iframeResizer', _.throttle(_.bind(iframeResizer, this), 200));

                $('#slider').unbind('click.iframeResize').bind('click.iframeResize', () => {
                    if ($('.rendition-iframe').length > 0) {
                        setTimeout(() => {
                            this.calculateIframeHeight(iframeEl);
                        }, 200);
                    }
                });
            }
        }, 500);
    }
    public componentWillUnmount() {
        this.stopDetectOffTheCuff();
    }

    public componentDidUpdate(preProps: IIFramePageProps) {
      if (preProps.hidden !== this.props.hidden && this.props.currentPage === "offTheCuff") {
          this.props.hidden ? this.stopDetectOffTheCuff() : this.startDetectcOffTheCuff();
      }
      if (preProps.iframePageUrl !== this.props.iframePageUrl && this.props.currentPage === "offTheCuff") {
        const iframePlaceHolderEl = $('.rendition-iframe-holder');
        const iframeEl = $('.rendition-iframe');
        iframePlaceHolderEl.height(150);
        iframeEl.height(150);
        iframePlaceHolderEl.addClass("overflow-hidden");
        iframeEl.addClass("overflow-hidden");
      }
    }
    public calculateIframeHeight(iframeEl: any) {
        if (this.props.currentPage == 'offTheCuff') {
            this.calculateHeightForOfftheCuff();
            return;
        }

        let iframeElHeight = ($(window).height() || 0) - iframeEl.offset().top - 5  /*For clearance*/;
        const iframeHolder = iframeEl.parent('.rendition-iframe-holder');
        let iframeElWidth = iframeHolder.parent().width() || iframeEl.offset().width;

        if (this.props.currentPage == 'StyleAndFactors' || this.props.currentPage === 'HouseViews') {
            iframeElWidth = '100%';
            if (deviceInfoService.isDeviceScreenType()) {
                iframeElWidth = 600;
            }
            iframeElHeight = this.props.currentPage === 'HouseViews' ? 610 : 596;   // modal of styleAndFactor is 700, 700 - 24 - 80
        }
        
        // set iframe height and width
        iframeEl.height(iframeElHeight);
        iframeEl.width(iframeElWidth);

        // set iframe holder height and width
        iframeHolder.height(iframeElHeight);
        iframeHolder.width(iframeElWidth);
    }

    public startDetectcOffTheCuff() {
        this.calculateIframeHeight($(this.elRef.current));
    }

    public stopDetectOffTheCuff() {
        this.intervalId && clearInterval(this.intervalId);
        this.eleIntervalId && clearInterval(this.eleIntervalId);
    }
    public render() {
        const {iframeADATitle, customScrollingOption, iframeId, iframeStyle, iframePageUrl, currentPage, iframeHolderStyle} = this.props;
        const iframeTitle = _.isEmpty(iframeADATitle) ? 'Iframe of' + currentPage.toUpperCase().replace(/([A-Z])/g, ' $1') : iframeADATitle;
        const scrolling = _.isEmpty(customScrollingOption) ? 'no' : customScrollingOption;
        return (
            <div className="rendition-iframe-holder" style={iframeHolderStyle}>
                <iframe
                  frameBorder="0"
                  className="rendition-iframe"
                  scrolling={scrolling}
                  onLoad={(e) => this.loaded(e)}
                  src={iframePageUrl}
                  title={iframeTitle}
                  ref={this.elRef}
                  id={iframeId}
                  style={iframeStyle}
                />
            </div>
        );
    }

    private loaded(e: any) {
        if (this.props.currentPage == 'offTheCuff') {
            this.startDetectcOffTheCuff();
            const iframePlaceHolderEl = $('.rendition-iframe-holder');
            const iframeEl = $('.rendition-iframe');
            iframePlaceHolderEl.removeClass("overflow-hidden");
            iframeEl.removeClass("overflow-hidden");
            return;
        }
        if (this.props.currentPage !== 'seriesPage') {
            return;
        }
        const bodyDom = $('.rendition-iframe').contents().find('body')[0];
        $(bodyDom).find('.serie-bar').hide();
        $(bodyDom).find('#branded_series').css('margin', '0');
        $(bodyDom).find('.cpb-container').css('padding', '0');
        $(bodyDom).find('.x-portlet.plain').css('margin', '0');

        if (!$('#slider').hasClass('collapsed')) {
            $('#slider').click();
            const target = $(e.currentTarget);
            setTimeout(() => {
                this.calculateIframeHeight(target);
            }, 200);
        }
    }
    private getIframeElement() {
      const iframeEl = $(this.elRef.current);
      if (!iframeEl) return null;
      const iframeElBody = iframeEl.contents().find('#root')[0];
      const iframeContents = iframeEl.contents();
      return iframeElBody ? { iframeElBody, iframeContents, iframeEl } : null;
    }

    private loopGetIframeElements() {
      const stopGetElementInterval = () => {
        this.eleIntervalId && clearInterval(this.eleIntervalId);
      };

      return new Promise<any>((resolve) => {
        const getEle = (callback?: () => void) => {
            const eles = this.getIframeElement();
            if (eles) {
               callback?.();
               resolve(eles);
             }
        };
        getEle();
        stopGetElementInterval();
        this.eleIntervalId = setInterval(() => getEle(() => stopGetElementInterval()), 50);
      });
    }
    private async calculateHeightForOfftheCuff() {
        this.intervalId && clearInterval(this.intervalId);
        this.eleOffsetHeight = 0;
        this.eleOffsetWidth = 0;
        this.loopGetIframeElements().then(({iframeElBody, iframeContents, iframeEl}) => {
            if (iframeElBody) {
                // important:  Don`t do anything that will cause the page to repaint or reflow in this interval
                this.intervalId = setInterval(() => {
                    const figureElement = iframeContents[0].getElementById("figureGalleryScrollTo");
                    if (figureElement) {
                        const figureGalleryScrollTo = $(figureElement);
                        this.triggerFGScrollEvent = true;
                        figureGalleryScrollTo.on("click", () => {
                            const attrVal = figureGalleryScrollTo.parents('#right-pane').find('.fg.carousel-item.active>div').attr("data-name");
                            this.triggerFGScrollEvent && $('html, body').animate({
                                scrollTop: iframeEl.contents().find(`.${attrVal}`).cvOffSet().top + iframeEl.cvOffSet().top - 68
                            });
                            this.triggerFGScrollEvent = false;
                        });
                    }

                    const iframeHolder = iframeEl.parent('.rendition-iframe-holder');
                    const iframeElWidth = iframeHolder.parent().width() || iframeEl.offset().width;
                    const iframeHeight = iframeElBody.offsetHeight;
                    if (!iframeElWidth) return;
                    try {
                        if (this.eleOffsetWidth !== iframeElWidth) {
                            iframeEl.width(iframeElWidth);
                            iframeHolder.width(iframeElWidth);
                            this.eleOffsetWidth = iframeElWidth;
                        }
                        if (iframeHeight > 150 && this.eleOffsetHeight !== iframeHeight) {
                            iframeEl.height(iframeHeight);
                            iframeHolder.height(iframeHeight);
                            this.eleOffsetHeight = iframeHeight;
                        }
                    } catch (error) {
                        console.log(error);
                        iframeEl.height(500);
                        iframeHolder.height(500);
                    }
                },  100);
            }
        });
    }
}

export default IFramePage;
